module.exports = __webpack_public_path__ + "static/46-59b13b879ed69e7dcd2f49163bda8b03.png";